/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type LoanStatementType = typeof LoanStatementType[keyof typeof LoanStatementType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LoanStatementType = {
  LEDGER_CARD: 'LEDGER_CARD',
  REPAYMENT_SCHEDULE: 'REPAYMENT_SCHEDULE',
} as const;
